import { forwardRef, FunctionComponent, ImgHTMLAttributes, Ref, PropsWithoutRef } from 'react';
import styled from 'styled-components';

import { ForwardProps } from '../../types';

export interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  /** The HTML alt attribute for the image. */
  alt: string;
  /** Ref for the wrapping element. */
  ref?: Ref<HTMLImageElement>;
}

export const StyledImage = styled.img`
  max-width: 100%;
`;

const Image: FunctionComponent<ImageProps & ForwardProps> = forwardRef(
  (props: PropsWithoutRef<ImageProps>, ref: Ref<HTMLImageElement>) => {
    const { alt, ...restProps } = props;
    return <StyledImage {...restProps} alt={alt} ref={ref} />;
  }
);

export default Image;
